<template>
  <div id="app">
    <video
      autoplay
      muted
      loop
      playsinline
      id="bg-video"
      v-if="$route.name == 'Home' || $route.path.includes('products')"
    >
      <source :src="bgVideoSrc" :type="bgVideoType" />
    </video>
    <Header class="hide-on-mobile" v-if="!isAuthPage" />
    <HeaderMobile class="show-on-mobile" v-if="!isAuthPage" />
    <main>
      <!-- {{ $store.state.imagensDeProduto }} -->
      <div class="container" v-if="false">
        <div class="p-2">
          {{ pageName }}
        </div>
      </div>
      <div class="col">
        <router-view />
      </div>
    </main>
    <ConsentimentoCookies />
    <InstitutionalPageSyncButton />
    <Footer class="hide-on-mobile" v-if="!isAuthPage" />
    <FooterMobile class="show-on-mobile" v-if="!isAuthPage" />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import HeaderMobile from "@/components/HeaderMobile.vue";
import Footer from "@/components/Footer.vue";
import FooterMobile from "@/components/FooterMobile.vue";
import ConsentimentoCookies from "@/components/ConsentimentoCookies.vue";
import InstitutionalPageSyncButton from "@/components/InstitutionalPageSyncButton.vue";
import { getPublicApiConfig } from "@/services/apiConfig.js";

export default {
  name: "App",
  components: {
    Header,
    HeaderMobile,
    ConsentimentoCookies,
    Footer,
    FooterMobile,
    InstitutionalPageSyncButton,
  },
  data() {
    return {
      psw: localStorage.getItem("psw"),
      baseUrl: process.env.BASE_URL,
      // Tema atual, usado para escolher a versão correta (clara/escura)
      // do vídeo de fundo do banner. Mesma fonte de verdade do
      // ThemeSwitcher (localStorage 'siteTheme').
      isDarkTheme: (() => {
        const previewTheme = new URLSearchParams(window.location.search).get('mx3_preview_theme');
        return previewTheme ? previewTheme !== 'light' : localStorage.getItem("siteTheme") !== "light";
      })(),
      // "Modo Edição" da tela Personalizar (Gerenciador de Produtos) -
      // ver onMx3ThemeEditModeMessage()/mx3SetEditModeActive() abaixo.
      mx3EditModeActive: false,
      mx3LogoMoveActive: false,
      // Vídeo de banner personalizado por tema (tela Personalizar > Vídeo
      // do Banner). "" = usa o vídeo padrão. mx3PreviewVideoOverride tem
      // prioridade quando estamos dentro do iframe de pré-visualização
      // (troca em tempo real, antes mesmo de publicar - ver
      // onMx3ThemePreviewMessage abaixo).
      mx3CustomVideoUrl: {
        dark: (window.MX3_THEME_MEDIA && window.MX3_THEME_MEDIA.dark && window.MX3_THEME_MEDIA.dark.videoUrl) || "",
        light: (window.MX3_THEME_MEDIA && window.MX3_THEME_MEDIA.light && window.MX3_THEME_MEDIA.light.videoUrl) || "",
      },
      mx3PreviewVideoOverride: null,
      // Evita que o watcher profundo salve [] enquanto a lista da conta
      // ainda está sendo recuperada do servidor.
      restaurandoDesejosDaConta: false,
    };
  },
  mounted() {
    let psw = localStorage.getItem("psw");
    if (!psw) {
      //this.$router.push({ name: "password" });
    }
    // Mantém o vídeo de fundo sincronizado quando o tema é alternado
    // (ThemeSwitcher emite este evento em toggleTheme()/onExternalThemeChange()).
    this.$root.$on("mx3-theme-changed", this.onThemeChangedForVideo);

    // Pré-visualização em tempo real da tela "Personalizar" (Gerenciador
    // de Produtos): quando este site é aberto dentro do iframe dessa
    // tela, o gerenciador tentava escrever diretamente no
    // <style id="mx3-preview-override"> via iframe.contentDocument. Isso
    // só funciona quando os dois estão na mesma origem - mas, na
    // configuração real (Gerenciador e E-commerce em domínios
    // diferentes, ver paths_config_manager.php), o navegador bloqueia
    // esse acesso entre origens (erro silencioso), e as cores em edição
    // nunca apareciam na pré-visualização. postMessage funciona entre
    // origens diferentes sem exigir nenhuma configuração extra, então o
    // e-commerce passa a aplicar a sobreposição de cores recebida por
    // essa via (além de continuar aceitando a escrita direta, quando a
    // origem coincidir).
    window.addEventListener("message", this.onMx3ThemePreviewMessage);
    // "Modo Edição" da tela Personalizar: liga/desliga a captura de
    // clique em elementos desta página quando o Gerenciador pede (ver
    // onMx3ThemeEditModeMessage abaixo).
    window.addEventListener("message", this.onMx3ThemeEditModeMessage);
    // Mapa de Elementos da tela Personalizar: "localizar/destacar" uma área
    // do site e "selecionar o elemento pai" do item atual do Modo Edição.
    window.addEventListener("message", this.onMx3ThemeLocateMessage);
    window.addEventListener("message", this.onMx3LogoMessage);
  },
  beforeDestroy() {
    this.$root.$off("mx3-theme-changed", this.onThemeChangedForVideo);
    window.removeEventListener("message", this.onMx3ThemePreviewMessage);
    window.removeEventListener("message", this.onMx3ThemeEditModeMessage);
    window.removeEventListener("message", this.onMx3ThemeLocateMessage);
    window.removeEventListener("message", this.onMx3LogoMessage);
    this.mx3SetLogoMoveActive(false);
    this.mx3SetEditModeActive(false);
  },
  computed: {
    bgVideoSrc() {
      const tema = this.isDarkTheme ? "dark" : "light";
      // Prioridade: 1) troca em tempo real vinda do Modo Edição/preview
      // do Gerenciador (ainda não publicada); 2) vídeo já publicado para
      // este tema (theme-media-config.js); 3) vídeo padrão do e-commerce.
      if (this.mx3PreviewVideoOverride && this.mx3PreviewVideoOverride.tema === tema) {
        return this.mx3PreviewVideoOverride.url || this.mx3DefaultVideoUrl(tema);
      }
      const customUrl = this.mx3CustomVideoUrl[tema];
      return customUrl || this.mx3DefaultVideoUrl(tema);
    },
    bgVideoType() {
      // O <source> declara o MIME certo pro arquivo atual - os vídeos
      // padrão são .webm, mas um vídeo enviado pela tela Personalizar
      // pode ser .mp4, e o navegador ignora o <source> se o "type"
      // declarado não bater com o arquivo de verdade.
      const src = this.bgVideoSrc || "";
      return src.toLowerCase().endsWith(".mp4") ? "video/mp4" : "video/webm";
    },
    isAuthPage() {
      console.log(this.$route.path);
      return ["/login", "/register", "/recovery"].includes(this.$route.path);
    },
    pageName() {
      if (this.$route.meta.isLogin) {
        return null;
      }
      let title = this.$route?.meta?.title ?? "";
      return title ? `Início / ${title}` : "";
    },
  },
  watch: {
    "$store.state.carrinho"(v) {
      localStorage.setItem(
        "itensCarrinho",
        JSON.stringify(this.$store.state.carrinho)
      );
      // Mantém o carrinho salvo vinculado à conta do cliente logado, para
      // que ele possa ser recuperado em um novo login (ver logout() em
      // AccountMenu.vue e restaurarCarrinhoDaConta() abaixo).
      if (localStorage.getItem("accessToken")) {
        this.$api
          .httpService()
          .post(window.location.origin + "/api/cart_save.php", {
            itens: this.$store.state.carrinho,
          })
          .catch((err) => console.error("Erro ao salvar carrinho da conta:", err));
      }
    },
    "$store.state.desejos": {
      deep: true,
      handler() {
      // A lista de desejos pertence à conta autenticada. Não gravamos
      // favoritos em localStorage para impedir que eles apareçam em outra
      // conta ou após o logout.
      if (localStorage.getItem("accessToken") && !this.restaurandoDesejosDaConta) {
        this.salvarDesejosDaConta();
      }
      },
    },
  },
  created() {
    let carrinho = localStorage.getItem("itensCarrinho");
    if (carrinho) {
      this.$store.state.carrinho = JSON.parse(carrinho);
    }

    // Favoritos são sempre carregados do servidor da conta. Qualquer
    // vestígio local de versões anteriores é removido para não misturar
    // desejos entre usuários.
    localStorage.removeItem("itensDesejo");
    this.$store.state.desejos = [];

    // Carrega configurações do site do localStorage ou da API
    let configuracoes = localStorage.getItem("configuracoesSite");
    if (configuracoes) {
      this.$store.state.configuracoesSite = JSON.parse(configuracoes);
    }
    this.loadConfiguracoesSite();

    if (localStorage.getItem("accessToken")) {
      if (!localStorage.getItem("carrinhoContaRestaurado")) {
        this.restaurarCarrinhoDaConta();
      }
      this.restaurarDesejosDaConta();
    }
  },
  methods: {
    // Atualiza a fonte do vídeo de fundo quando o tema é alternado e
    // força o elemento <video> a recarregar (mudar apenas o :src do
    // <source> não recarrega o vídeo automaticamente).
    onThemeChangedForVideo(isDark) {
      if (this.isDarkTheme === isDark) return;
      this.isDarkTheme = isDark;
      this.$nextTick(() => {
        const video = document.getElementById("bg-video");
        if (video) {
          video.load();
          video.play().catch(() => {});
        }
      });
    },
    // Aplica (ou remove) a folha de sobreposição de cores enviada pela
    // tela "Personalizar" do Gerenciador de Produtos, quando este site
    // está sendo exibido dentro do iframe de pré-visualização daquela
    // tela. Ver comentário em mounted() sobre por que isso usa
    // postMessage em vez de acesso direto ao DOM do iframe.
    onMx3ThemePreviewMessage(event) {
      const data = event && event.data;
      if (!data || data.source !== "mx3-theme-customizer-preview") return;
      let styleEl = document.getElementById("mx3-preview-override");
      if (!styleEl) {
        styleEl = document.createElement("style");
        styleEl.id = "mx3-preview-override";
        document.head.appendChild(styleEl);
      }
      styleEl.textContent = data.css || "";
      // Vídeo do banner em pré-visualização (tela Personalizar > Vídeo do
      // Banner) - troca em tempo real, antes de publicar. "videoTema" e
      // "videoUrl" são opcionais (só vêm quando o admin mexeu no vídeo).
      if (data.videoTema) {
        this.mx3PreviewVideoOverride = { tema: data.videoTema, url: data.videoUrl || "" };
        this.$nextTick(() => {
          const video = document.getElementById("bg-video");
          if (video) {
            video.load();
            video.play().catch(() => {});
          }
        });
      }
    },
    mx3DefaultVideoUrl(tema) {
      return tema === "dark"
        ? `${this.baseUrl}datacenter-video.webm`
        : `${this.baseUrl}datacenter-video-light.webm`;
    },
    // ---------------------------------------------------------------
    // "Modo Edição" da tela Personalizar (Gerenciador de Produtos)
    // ---------------------------------------------------------------
    // Quando o admin liga o "Modo Edição" no Gerenciador, esta página
    // (carregada dentro do iframe de pré-visualização) passa a: (1)
    // destacar com um contorno o elemento sob o mouse, e (2) capturar o
    // próximo clique em vez de deixá-lo navegar normalmente, extraindo
    // um seletor CSS estável e as cores atuais do elemento clicado para
    // enviar de volta ao Gerenciador (via postMessage - necessário
    // porque os dois normalmente ficam em domínios diferentes).
    onMx3ThemeEditModeMessage(event) {
      const data = event && event.data;
      if (!data || data.source !== "mx3-theme-customizer-editmode") return;
      this.mx3SetEditModeActive(!!data.active);
    },
    mx3SetEditModeActive(active) {
      if (this.mx3EditModeActive === active) return;
      this.mx3EditModeActive = active;
      if (active) {
        document.addEventListener("click", this.mx3OnEditModeClick, true);
        // O <select> "Ordenar por" abre a lista nativa já no mousedown, antes
        // do clique: bloqueamos para o Modo Edição apenas SELECIONAR o item.
        ["mousedown", "pointerdown", "touchstart"].forEach((t) => document.addEventListener(t, this.mx3OnEditModeBlockSelect, true));
        document.addEventListener("mouseover", this.mx3OnEditModeMouseOver, true);
        document.addEventListener("mouseout", this.mx3OnEditModeMouseOut, true);
        document.addEventListener("keydown", this.mx3OnEditModeKeyDown, true);
      } else {
        document.removeEventListener("click", this.mx3OnEditModeClick, true);
        ["mousedown", "pointerdown", "touchstart"].forEach((t) => document.removeEventListener(t, this.mx3OnEditModeBlockSelect, true));
        document.removeEventListener("mouseover", this.mx3OnEditModeMouseOver, true);
        document.removeEventListener("mouseout", this.mx3OnEditModeMouseOut, true);
        document.removeEventListener("keydown", this.mx3OnEditModeKeyDown, true);
        if (this._mx3HoverEl) {
          this._mx3HoverEl.style.outline = this._mx3HoverElPrevOutline || "";
          this._mx3HoverEl.style.cursor = this._mx3HoverElPrevCursor || "";
          this._mx3HoverEl = null;
        }
      }
    },
    // Enquanto o clique é capturado aqui dentro do e-commerce (iframe), o
    // FOCO do teclado também fica aqui - por isso Delete/Ctrl+Z, mesmo
    // configurados no Gerenciador, não chegam lá sem ajuda. Repassamos via
    // postMessage, do mesmo jeito que já fazemos com o elemento clicado.
    mx3OnEditModeKeyDown(ev) {
      if (!this.mx3EditModeActive) return;
      const alvo = ev.target;
      const emCampoDeTexto = alvo && (["INPUT", "TEXTAREA", "SELECT"].includes(alvo.tagName) || alvo.isContentEditable);
      if (emCampoDeTexto) return; // não interfere ao digitar em campos do próprio site
      const isUndo = (ev.ctrlKey || ev.metaKey) && !ev.shiftKey && (ev.key === "z" || ev.key === "Z");
      const isDelete = ev.key === "Delete" || ev.key === "Backspace";
      if (!isUndo && !isDelete) return;
      ev.preventDefault();
      ev.stopPropagation();
      window.parent.postMessage({
        source: "mx3-theme-customizer-keyboard",
        action: isUndo ? "undo" : "delete",
      }, "*");
    },
    mx3OnEditModeMouseOver(ev) {
      const el = ev.target;
      if (!el || el.nodeType !== 1 || el === document.documentElement || el === document.body) return;
      if (this._mx3HoverEl && this._mx3HoverEl !== el) {
        this._mx3HoverEl.style.outline = this._mx3HoverElPrevOutline || "";
        this._mx3HoverEl.style.cursor = this._mx3HoverElPrevCursor || "";
      }
      this._mx3HoverElPrevOutline = el.style.outline;
      this._mx3HoverElPrevCursor = el.style.cursor;
      el.style.outline = "2px dashed #f0ad4e";
      el.style.cursor = "pointer";
      this._mx3HoverEl = el;
    },
    mx3OnEditModeMouseOut(ev) {
      const el = ev.target;
      if (el && this._mx3HoverEl === el) {
        el.style.outline = this._mx3HoverElPrevOutline || "";
        el.style.cursor = this._mx3HoverElPrevCursor || "";
        this._mx3HoverEl = null;
      }
    },
    mx3OnEditModeBlockSelect(ev) {
      if (!this.mx3EditModeActive) return;
      const el = ev.target;
      if (el && el.nodeType === 1 && (el.tagName === "SELECT" || el.closest(".header-sort-select-overlay"))) {
        ev.preventDefault();
        ev.stopPropagation();
      }
    },
    // Áreas do "Mapa de Elementos" relacionadas ao item clicado. Serve para
    // partes que não dá para ajustar direto pelo clique (ícone coberto pelo
    // <select> invisível, lista nativa de opções, listas suspensas que fecham
    // ao tirar o mouse, faixas atrás de outros itens). "only": o painel
    // mostra SÓ essas áreas (o próprio elemento clicado não tem cor útil).
    mx3GetMapaAreas() {
      return [
        { sel: ".header-search-sort, .header-sort-select-overlay, .header-sort-icon-visual", only: true, keys: ["hdr_sort_icon", "hdr_sort_options", "hdr_sort_select", "hdr_search_box", "hdr_search_icon"], label: "Campo de busca e botão 'Ordenar por'" },
        { sel: ".navmenu .dropdown ul", only: false, keys: ["hdr_dropdown_text", "hdr_dropdown_items", "hdr_dropdown", "hdr_dropdown_active"], label: "Lista suspensa do cabeçalho" },
        { sel: ".header-top-links", only: false, keys: ["hdr_top_strip"], label: "Faixa estreita superior" },
        { sel: ".header-category-bar", only: false, keys: ["hdr_cat_bar"], label: "Faixa estreita inferior" },
        { sel: ".guarantees-grid, .guarantees-section, .guarantees-row-wrapper", only: false, keys: ["gar_row", "gar_grid"], label: "Seção de garantias" },
      ];
    },
    mx3OnEditModeClick(ev) {
      if (!this.mx3EditModeActive) return;
      const el = ev.target;
      if (!el || el.nodeType !== 1 || el === document.documentElement || el === document.body) return;
      ev.preventDefault();
      ev.stopPropagation();
      this.mx3EmitPicked(el);
    },
    // Monta e envia ao Gerenciador os dados do elemento escolhido (por
    // clique, ou pelo botão "Selecionar o elemento pai").
    mx3EmitPicked(el) {
      const selector = this.mx3BuildSelector(el);
      if (!selector) return;
      const insp = this.mx3InspectElement(el);
      const textoResumo = this.mx3GetElementLabelText(el).slice(0, 28);
      const label = el.tagName.toLowerCase() + (textoResumo ? `: "${textoResumo}"` : "");
      // Este elemento pertence a um dos "conjuntos" com ajuste em grupo
      // (cards de produto, quadros de garantia, células da barra lateral
      // de categorias, quadros do banner/carrossel e abas do cabeçalho)?
      // Se sim, calculamos também o seletor "de grupo" (sem o
      // :nth-of-type do item que se repete), para que o ajuste valha
      // para todo o conjunto por padrão - ver mx3FindGroupRoot().
      const grupo = this.mx3FindGroupRoot(el);
      let groupSelector = null;
      let groupLabel = null;
      if (grupo) {
        const seletorDeGrupo = this.mx3BuildSelector(el, { skipNthAt: grupo.root });
        // Se não houver diferença (ex.: conjunto com um único item no
        // momento), não faz sentido oferecer a opção "grupo x individual".
        if (seletorDeGrupo && seletorDeGrupo !== selector) {
          groupSelector = seletorDeGrupo;
          groupLabel = grupo.label;
        }
      }
      // Este elemento representa diretamente uma das 6 cores base do
      // site (fundo geral, texto padrão, títulos, destaque, fundo de
      // cards/caixas, texto sobre destaque) e não pertence a nenhum dos
      // conjuntos acima? Ver mx3DetectBaseVar().
      const baseVar = grupo ? null : this.mx3DetectBaseVar(el);
      let mapaAreas = null;
      for (const a of this.mx3GetMapaAreas()) {
        let casa = false;
        try { casa = !!el.closest(a.sel); } catch (e) { casa = false; }
        if (casa) { mapaAreas = a; break; }
      }
      window.parent.postMessage({
        source: "mx3-theme-customizer-elementpicked",
        payload: {
          selector,
          groupSelector,
          groupLabel,
          label,
          baseVar: baseVar ? baseVar.key : null,
          baseVarLabel: baseVar ? baseVar.label : null,
          baseVarDual: !!(baseVar && baseVar.dual),
          mapaKeys: mapaAreas ? mapaAreas.keys : null,
          mapaOnly: !!(mapaAreas && mapaAreas.only),
          mapaLabel: mapaAreas ? mapaAreas.label : null,
          ...insp,
        },
      }, "*");
    },
    // ---------------------------------------------------------------
    // Posicionar a logomarca do cabeçalho (tela Personalizar)
    // ---------------------------------------------------------------
    // Mensagens do Gerenciador: "logoset" aplica (ao vivo) a posição digitada
    // nos campos/setas do painel; "logomove" liga/desliga o modo em que a
    // logomarca pode ser selecionada, arrastada e movida com as setas do
    // teclado. A posição é guardada nas variáveis --mx3-logo-top/left (as
    // mesmas usadas pelo CSS publicado) e devolvida ao Gerenciador.
    onMx3LogoMessage(event) {
      const data = event && event.data;
      if (!data) return;
      if (data.source === "mx3-theme-customizer-logoset") {
        this.mx3ApplyLogoPos(data.top, data.left);
      } else if (data.source === "mx3-theme-customizer-logomove") {
        this.mx3SetLogoMoveActive(!!data.active);
      }
    },
    mx3LogoEl() {
      return document.querySelector("#header:not(.header-scrolled) .main-header-row > .logo .logo-site-img")
        || document.querySelector("#header .main-header .logo .logo-site-img");
    },
    mx3ApplyLogoPos(top, left) {
      const root = document.documentElement;
      const num = (v) => (v === null || v === undefined || v === "" || isNaN(Number(v))) ? null : Number(v);
      const t = num(top);
      const l = num(left);
      if (t === null) root.style.removeProperty("--mx3-logo-top");
      else root.style.setProperty("--mx3-logo-top", t + "px", "important");
      if (l === null) root.style.removeProperty("--mx3-logo-left");
      else root.style.setProperty("--mx3-logo-left", l + "px", "important");
    },
    mx3CurrentLogoPos() {
      const img = this.mx3LogoEl();
      const cs = img ? window.getComputedStyle(img) : null;
      return {
        top: cs ? Math.round(parseFloat(cs.top) || 0) : -16,
        left: cs ? Math.round(parseFloat(cs.left) || 0) : 0,
      };
    },
    mx3EmitLogoPos(top, left, phase) {
      this.mx3ApplyLogoPos(top, left);
      window.parent.postMessage({ source: "mx3-theme-customizer-logopos", top, left, phase }, "*");
    },
    mx3SetLogoMoveActive(active) {
      if (this.mx3LogoMoveActive === active) return;
      this.mx3LogoMoveActive = active;
      const ev = ["pointerdown", "click", "keydown"];
      const handlers = {
        pointerdown: this.mx3OnLogoPointerDown,
        click: this.mx3OnLogoClick,
        keydown: this.mx3OnLogoKeyDown,
      };
      let st = document.getElementById("mx3-logomove-style");
      if (active) {
        window.scrollTo(0, 0);
        if (!st) {
          st = document.createElement("style");
          st.id = "mx3-logomove-style";
          st.textContent =
            "html.mx3-logomove #header .logo .logo-site-img{outline:2px dashed #f0ad4e !important;outline-offset:3px;cursor:move !important;touch-action:none;-webkit-user-drag:none;user-select:none}" +
            "html.mx3-logomove #header .logo .logo-site-img.mx3-logo-selected{outline:2px solid #f0ad4e !important;box-shadow:0 0 0 4px rgba(240,173,78,.25)}";
          document.head.appendChild(st);
        }
        document.documentElement.classList.add("mx3-logomove");
        ev.forEach((t) => document.addEventListener(t, handlers[t], true));
      } else {
        ev.forEach((t) => document.removeEventListener(t, handlers[t], true));
        document.documentElement.classList.remove("mx3-logomove");
        const img = this.mx3LogoEl();
        if (img) img.classList.remove("mx3-logo-selected");
        this._mx3LogoDrag = null;
      }
    },
    mx3IsLogoTarget(el) {
      return !!(el && el.nodeType === 1 && el.closest && el.closest("#header .main-header .logo"));
    },
    mx3OnLogoClick(ev) {
      if (!this.mx3IsLogoTarget(ev.target)) return;
      ev.preventDefault();
      ev.stopPropagation();
    },
    mx3OnLogoPointerDown(ev) {
      if (ev.button !== undefined && ev.button !== 0) return;
      const img = this.mx3LogoEl();
      if (!img || !this.mx3IsLogoTarget(ev.target)) {
        // clique fora da logomarca: tira a seleção (as setas deixam de mover)
        if (img) img.classList.remove("mx3-logo-selected");
        return;
      }
      ev.preventDefault();
      ev.stopPropagation();
      img.classList.add("mx3-logo-selected");
      const pos = this.mx3CurrentLogoPos();
      this._mx3LogoDrag = { x: ev.clientX, y: ev.clientY, top: pos.top, left: pos.left, moved: false };
      window.parent.postMessage({ source: "mx3-theme-customizer-logopos", top: pos.top, left: pos.left, phase: "start" }, "*");
      const move = (e) => {
        const d = this._mx3LogoDrag;
        if (!d) return;
        const dx = e.clientX - d.x;
        const dy = e.clientY - d.y;
        if (!d.moved && Math.abs(dx) < 2 && Math.abs(dy) < 2) return;
        d.moved = true;
        e.preventDefault();
        this.mx3EmitLogoPos(Math.round(d.top + dy), Math.round(d.left + dx), "move");
      };
      const up = () => {
        document.removeEventListener("pointermove", move, true);
        document.removeEventListener("pointerup", up, true);
        document.removeEventListener("pointercancel", up, true);
        this._mx3LogoDrag = null;
        window.parent.postMessage({ source: "mx3-theme-customizer-logopos", phase: "end" }, "*");
      };
      document.addEventListener("pointermove", move, true);
      document.addEventListener("pointerup", up, true);
      document.addEventListener("pointercancel", up, true);
    },
    mx3OnLogoKeyDown(ev) {
      const img = this.mx3LogoEl();
      if (!img || !img.classList.contains("mx3-logo-selected")) return;
      const k = ev.key;
      if (k === "Escape") { img.classList.remove("mx3-logo-selected"); return; }
      const alvo = ev.target;
      if (alvo && (["INPUT", "TEXTAREA", "SELECT"].includes(alvo.tagName) || alvo.isContentEditable)) return;
      const passo = ev.shiftKey ? 10 : 1;
      let dx = 0, dy = 0;
      if (k === "ArrowUp") dy = -passo;
      else if (k === "ArrowDown") dy = passo;
      else if (k === "ArrowLeft") dx = -passo;
      else if (k === "ArrowRight") dx = passo;
      else return;
      ev.preventDefault();
      ev.stopPropagation();
      const pos = this.mx3CurrentLogoPos();
      this.mx3EmitLogoPos(pos.top + dy, pos.left + dx, "nudge");
    },
    // ---------- Mapa de Elementos: localizar / elemento pai ----------
    onMx3ThemeLocateMessage(event) {
      const data = event && event.data;
      if (!data) return;
      if (data.source === "mx3-theme-customizer-select-parent") {
        let atual = null;
        try { atual = document.querySelector(data.selector); } catch (e) { atual = null; }
        let pai = atual && atual.parentElement;
        while (pai && pai.tagName && pai.tagName.toLowerCase() === "html") pai = null;
        if (!pai || pai === document.body) return;
        this.mx3EmitPicked(pai);
        return;
      }
      if (data.source !== "mx3-theme-customizer-locate") return;
      // Listas suspensas (Categorias/Serviços) só aparecem com o mouse em
      // cima; ao localizar uma delas mantemos a lista aberta por alguns
      // segundos para dar para ver o resultado do ajuste.
      const estiloAberto = document.getElementById("mx3-force-open");
      if (estiloAberto) estiloAberto.remove();
      if (data.open && /^[\w\s.#>\-\[\]=*:"',]+$/.test(String(data.open))) {
        const st = document.createElement("style");
        st.id = "mx3-force-open";
        st.textContent = `${data.open}{opacity:1 !important;visibility:visible !important;top:100% !important;display:block !important;}`;
        document.head.appendChild(st);
        setTimeout(() => { const x = document.getElementById("mx3-force-open"); if (x) x.remove(); }, 12000);
      }
      const responder = (el) => {
        const resp = { source: "mx3-theme-customizer-locate-result", key: data.key, tema: data.tema, found: !!el };
        if (el) {
          const cs = getComputedStyle(el);
          resp.bg = this.mx3RgbToHex(cs.backgroundColor);
          resp.color = this.mx3RgbToHex(cs.color);
          resp.border = this.mx3RgbToHex(cs.borderTopColor);
        }
        try { window.parent.postMessage(resp, "*"); } catch (e) { /* ignora */ }
      };
      const achar = () => {
        const partes = String(data.sel || "").split(",").map((x) => x.trim()).filter(Boolean);
        for (const p of partes) {
          let lista = [];
          try { lista = Array.from(document.querySelectorAll(p)); } catch (e) { continue; }
          const visivel = lista.find((n) => { const r = n.getBoundingClientRect(); return r.width > 0 && r.height > 0; });
          if (visivel) return visivel;
        }
        return null;
      };
      const destacar = (el) => {
        try { el.scrollIntoView({ block: "center", inline: "nearest", behavior: "smooth" }); } catch (e) { /* ignora */ }
        const antes = { o: el.style.outline, f: el.style.outlineOffset };
        el.style.outline = "3px solid #ff3b9a";
        el.style.outlineOffset = "-3px";
        setTimeout(() => { el.style.outline = antes.o; el.style.outlineOffset = antes.f; }, 1800);
      };
      let el = achar();
      if (el) { destacar(el); responder(el); return; }
      // Não está na página atual: tenta abrir a página onde ele costuma ficar.
      const alvoPagina = data.page && this.$route.path.replace(/\/$/, "") !== String(data.page).replace(/\/$/, "");
      if (alvoPagina) {
        this.$router.push(data.page).catch(() => {});
        setTimeout(() => {
          el = achar();
          if (el) destacar(el);
          responder(el);
        }, 1500);
      } else {
        responder(null);
      }
    },
    // ---------- "Conjuntos" com ajuste em grupo x individual ----------
    // Cada grupo aponta para a classe CSS do item que SE REPETE (o card,
    // o quadro, a célula...). mx3FindGroupRoot() sobe a árvore a partir
    // do elemento clicado procurando o item do conjunto ao qual ele
    // pertence (o próprio elemento clicado ou algum ancestral).
    mx3GetElementGroups() {
      return [
        { id: "product-card", rootSelector: ".produto-card-custom", label: "Cards de produtos" },
        { id: "guarantee-item", rootSelector: ".guarantee-item", label: "Quadros da seção de garantias" },
        { id: "category-item", rootSelector: ".category-item", label: "Células da barra lateral de categorias" },
        { id: "stat-card", rootSelector: ".stat-card", label: "Quadros do banner/carrossel" },
        // Itens das listas suspensas do cabeçalho (Categorias/Serviços).
        // Fica ANTES de "nav-tab-item" porque esses <li> estão dentro de um
        // <li class="nav-tab-item"> e precisam ser reconhecidos primeiro.
        { id: "nav-dropdown-item", rootSelector: ".navmenu .dropdown ul > li", label: "Itens das listas suspensas do cabeçalho (Categorias/Serviços)" },
        // Marcador adicionado nos <li> de nível superior da faixa de
        // categorias do cabeçalho (Início, Categorias, Serviços, etc.) -
        // ver Header.vue.
        { id: "nav-tab-item", rootSelector: ".nav-tab-item", label: "Abas do menu do cabeçalho" },
      ];
    },
    mx3FindGroupRoot(el) {
      const grupos = this.mx3GetElementGroups();
      for (const grupo of grupos) {
        const root = el.closest(grupo.rootSelector);
        if (root) return { ...grupo, root };
      }
      return null;
    },
    // ---------- As 6 cores base do site (antiga seção "Cores Globais") ----------
    // Em vez de uma seção fixa no painel, essas cores continuam
    // editáveis clicando no elemento correspondente: comparamos a cor
    // JÁ RESOLVIDA do elemento clicado com o valor atual de cada
    // variável CSS raiz - se baterem (e o elemento não pertencer a um
    // dos conjuntos acima, que têm sua própria lógica de grupo/
    // individual), o clique edita a cor base (afeta o site inteiro),
    // em vez de criar uma personalização só daquele elemento.
    mx3DetectBaseVar(el) {
      const raiz = getComputedStyle(document.documentElement);
      const varAtual = (nome) => (raiz.getPropertyValue(nome) || "").trim();
      const cs = getComputedStyle(el);
      const elBg = this.mx3RgbToHex(cs.backgroundColor);
      const elColor = this.mx3RgbToHex(cs.color);
      const tag = el.tagName.toLowerCase();
      const ehTitulo = /^h[1-6]$/.test(tag);
      const bate = (valorEl, nomeVar) => {
        const v = varAtual(nomeVar);
        return !!valorEl && !!v && valorEl.toLowerCase() === v.toLowerCase();
      };
      if (bate(elBg, "--background-color")) {
        return { key: "background_color", label: "Fundo geral do site", dual: false };
      }
      if (bate(elBg, "--surface-color")) {
        return { key: "surface_color", label: "Fundo de cards/caixas (cor base do site)", dual: true };
      }
      if (bate(elColor, "--contrast-color")) {
        return { key: "contrast_color", label: "Texto sobre destaque (cor base do site)", dual: true };
      }
      if (ehTitulo && bate(elColor, "--heading-color")) {
        return { key: "heading_color", label: "Cor de títulos (cor base do site)", dual: true };
      }
      if (bate(elColor, "--accent-color") || bate(elBg, "--accent-color")) {
        return { key: "accent_color", label: "Cor de destaque (cor base do site)", dual: true };
      }
      if (bate(elColor, "--default-color")) {
        return { key: "default_color", label: "Texto padrão do site", dual: false };
      }
      return null;
    },
    // el.textContent gruda o texto de blocos filhos adjacentes sem
    // espaço nenhum entre eles (ex.: um <h5>Compra Segura</h5> seguido
    // de <p>Certificado SSL</p> vira "Compra SeguraCertificado SSL" no
    // rótulo mostrado no Gerenciador). Aqui inserimos um espaço entre
    // o texto de cada nó, dando "Compra Segura Certificado SSL".
    mx3GetElementLabelText(el) {
      const partes = [];
      const percorrer = (node) => {
        if (node.nodeType === 3) {
          const t = node.textContent.trim();
          if (t) partes.push(t);
        } else if (node.nodeType === 1) {
          node.childNodes.forEach(percorrer);
        }
      };
      percorrer(el);
      return partes.join(" ");
    },
    // Gera um seletor CSS razoavelmente estável para o elemento clicado:
    // usa #id quando existir; senão monta um caminho tag(.classes
    // estáveis)?(:nth-of-type quando há irmãos do mesmo tipo) subindo
    // até 6 níveis - suficiente para identificar o elemento sem
    // depender de classes utilitárias/dinâmicas (ex.: as de
    // animação/estado do Vue, filtradas abaixo).
    // "opts.skipNthAt", quando informado, é o elemento (ancestral do
    // clicado) que é a RAIZ de um item repetido de um conjunto (ex.: um
    // card de produto específico dentro da grade). Omitir o
    // :nth-of-type só nesse nível produz um seletor que casa com TODOS
    // os itens do conjunto (o ajuste em grupo) em vez de só aquele -
    // ver mx3FindGroupRoot()/mx3OnEditModeClick().
    mx3BuildSelector(el, opts) {
      const skipNthAt = opts && opts.skipNthAt;
      const parts = [];
      let node = el;
      let depth = 0;
      while (node && node.nodeType === 1 && node.tagName.toLowerCase() !== "html" && depth < 8) {
        if (node.id) {
          parts.unshift("#" + CSS.escape(node.id));
          break;
        }
        let parte = node.tagName.toLowerCase();
        const classesEstaveis = Array.from(node.classList || [])
          .filter((c) => c && !/^(fade|enter|leave|active|show|hide|hover)/i.test(c))
          .slice(0, 2);
        if (classesEstaveis.length) {
          parte += "." + classesEstaveis.map((c) => CSS.escape(c)).join(".");
        }
        const pai = node.parentElement;
        if (pai && node !== skipNthAt) {
          const irmaosMesmoTipo = Array.from(pai.children).filter((s) => s.tagName === node.tagName);
          if (irmaosMesmoTipo.length > 1) {
            parte += `:nth-of-type(${irmaosMesmoTipo.indexOf(node) + 1})`;
          }
        }
        parts.unshift(parte);
        node = node.parentElement;
        depth++;
      }
      return parts.join(" > ");
    },
    mx3RgbToHex(rgbStr) {
      if (!rgbStr) return "";
      const m = String(rgbStr).match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*([\d.]+))?\)/i);
      if (!m) return "";
      if (m[4] !== undefined && parseFloat(m[4]) === 0) return ""; // transparente
      const toHex = (n) => Number(n).toString(16).padStart(2, "0");
      return "#" + toHex(m[1]) + toHex(m[2]) + toHex(m[3]);
    },
    // Detecta se o elemento tem borda visível e se existe alguma regra
    // ":hover" no CSS do site que se aplique a ele, reaproveitando (sem
    // o sufixo ":hover") o próprio seletor da regra para checar
    // el.matches(). Sempre que possível, também extrai a cor de fundo/
    // texto usadas nesse hover, para pré-preencher os campos no
    // Gerenciador.
    mx3InspectElement(el) {
      const cs = window.getComputedStyle(el);
      // Checa as 4 bordas (não só a de cima): títulos como "Categorias"
      // costumam usar só border-bottom (uma linha por baixo do texto), e
      // antes isso não era detectado - o campo "Cor da borda" nunca
      // aparecia pra esses elementos, mesmo a borda existindo de verdade.
      const temBorda = (largura, estilo) => (parseFloat(largura) || 0) > 0 && estilo !== "none";
      const hasBorder = temBorda(cs.borderTopWidth, cs.borderTopStyle) ||
        temBorda(cs.borderRightWidth, cs.borderRightStyle) ||
        temBorda(cs.borderBottomWidth, cs.borderBottomStyle) ||
        temBorda(cs.borderLeftWidth, cs.borderLeftStyle);
      // Detecta o padrão "texto com gradiente" (ex.: título grande do
      // banner): o texto normalmente é preenchido via -webkit-text-fill-
      // color transparente + background-clip:text, então trocar apenas
      // "color" ou "background-color" não muda nada visualmente - é
      // preciso tratar esse caso à parte (ver textClip abaixo e a
      // geração de CSS em theme_customizer_manager.js/theme_config_manager.php).
      const fillColor = cs.webkitTextFillColor || cs.textFillColor || "";
      const bgClip = cs.webkitBackgroundClip || cs.backgroundClip || "";
      const fillMatch = String(fillColor).match(/rgba?\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*(?:,\s*([\d.]+)\s*)?\)/i);
      const fillIsTransparent = fillColor === "transparent" || (fillMatch && fillMatch[1] !== undefined && parseFloat(fillMatch[1]) === 0);
      const textClip = bgClip.indexOf("text") !== -1 && fillIsTransparent;
      let hasHover = false;
      let hoverBackground = "";
      let hoverColor = "";
      // Estado "ao ser clicado" (ex.: categoria/aba selecionada, item de
      // paginação ativo): mesma técnica do hover acima, mas procurando
      // regras cujo seletor combine o elemento com uma classe de
      // estado "ativo/selecionado" já usada no projeto.
      let hasActive = false;
      let activeBackground = "";
      let activeColor = "";
      let activeClass = ""; // ex.: ".is-active" - a classe de estado que casou (ver abaixo)
      const REGEX_CLASSE_ATIVA = /\.(is-active|active|selected)\b/;
      try {
        for (const sheet of document.styleSheets) {
          let rules;
          try {
            rules = sheet.cssRules || sheet.rules;
          } catch (e) {
            continue; // folha de outra origem (ex.: Google Fonts) - ignora
          }
          if (!rules) continue;
          for (const rule of rules) {
            if (!rule.selectorText) continue;
            if (rule.selectorText.indexOf(":hover") !== -1) {
              const seletorBase = rule.selectorText.replace(/:hover/g, "");
              try {
                if (seletorBase && el.matches(seletorBase)) {
                  hasHover = true;
                  if (rule.style && rule.style.backgroundColor) {
                    hoverBackground = this.mx3RgbToHex(rule.style.backgroundColor) || hoverBackground;
                  }
                  if (rule.style && rule.style.color) {
                    hoverColor = this.mx3RgbToHex(rule.style.color) || hoverColor;
                  }
                }
              } catch (e) {
                // seletor inválido/incompatível com este elemento - ignora
              }
            } else if (REGEX_CLASSE_ATIVA.test(rule.selectorText)) {
              // Remove a classe de estado ativo do seletor para checar
              // se o elemento CASARIA com ele quando ativo (mesmo que
              // ainda não esteja, no momento do clique).
              const seletorSemAtivo = rule.selectorText.replace(REGEX_CLASSE_ATIVA, "");
              try {
                if (seletorSemAtivo && seletorSemAtivo !== rule.selectorText && el.matches(seletorSemAtivo)) {
                  hasActive = true;
                  const casouClasse = rule.selectorText.match(REGEX_CLASSE_ATIVA);
                  if (casouClasse) activeClass = "." + casouClasse[1];
                  if (rule.style && rule.style.backgroundColor) {
                    activeBackground = this.mx3RgbToHex(rule.style.backgroundColor) || activeBackground;
                  }
                  if (rule.style && rule.style.color) {
                    activeColor = this.mx3RgbToHex(rule.style.color) || activeColor;
                  }
                }
              } catch (e) {
                // seletor inválido/incompatível com este elemento - ignora
              }
            }
          }
        }
      } catch (e) {
        // document.styleSheets indisponível por algum motivo - segue sem hover/ativo
      }
      return {
        // Enviados apenas como REFERÊNCIA (placeholder) no Gerenciador -
        // não devem ser aplicados automaticamente como override, senão a
        // cor do elemento muda sozinha assim que ele é selecionado.
        currentBackground: this.mx3RgbToHex(cs.backgroundColor),
        currentColor: textClip ? "" : this.mx3RgbToHex(cs.color),
        textClip,
        hasBorder,
        hasHover,
        hoverBackground,
        hoverColor,
        hasActive,
        activeBackground,
        activeColor,
        activeClass,
      };
    },
    // Busca o carrinho salvo vinculado à conta do cliente logado e o
    // combina com o que já estiver no navegador (ex.: itens adicionados
    // como visitante antes de logar), dando sequência à lista até que o
    // pedido seja concluído. Roda só uma vez por login (flag
    // "carrinhoContaRestaurado") - depois disso o carrinho local já fica
    // sincronizado com o servidor a cada mudança (ver watch acima), então
    // buscar de novo a cada recarregamento de página duplicaria os itens.
    restaurarDesejosDaConta() {
      this.restaurandoDesejosDaConta = true;
      this.$api
        .httpService()
        .get(window.location.origin + "/api/wishlist_get.php")
        .then((res) => {
          const itens = Array.isArray(res?.data?.itens)
            ? res.data.itens.map((id) => String(id))
            : [];
          this.$store.state.desejos = itens;
        })
        .catch((err) => console.error("Erro ao restaurar lista de desejos da conta:", err))
        .finally(() => {
          this.restaurandoDesejosDaConta = false;
        });
    },
    salvarDesejosDaConta() {
      this.$api
        .httpService()
        .post(window.location.origin + "/api/wishlist_save.php", {
          itens: this.$store.state.desejos || [],
        })
        .catch((err) => console.error("Erro ao salvar lista de desejos da conta:", err));
    },
    restaurarCarrinhoDaConta() {
      this.$api
        .httpService()
        .get(window.location.origin + "/api/cart_get.php")
        .then((res) => {
          localStorage.setItem("carrinhoContaRestaurado", "sim");

          const itensDaConta = res?.data?.itens || [];
          if (!itensDaConta.length) return;

          const carrinhoAtual = this.$store.state.carrinho || [];
          this.$store.state.carrinho = [...carrinhoAtual, ...itensDaConta];
        })
        .catch((err) => console.error("Erro ao restaurar carrinho da conta:", err));
    },
    loadConfiguracoesSite() {
      console.log("[DEBUG] Carregando configurações do site...");

      // Limpa o cache para forçar buscar dados atualizados
      localStorage.removeItem('configuracoes_publicas_cache');
      localStorage.removeItem('configuracoes_publicas_timestamp');

      // As configurações públicas do site (ex.: "ocultar preço para quem
      // não está logado") são hoje gerenciadas na tela "Configurações"
      // (aba "Exibição de Preços") do Gerenciador de Produtos, e não mais
      // no antigo backend Railway/Django - que foi desativado e não recebe
      // mais atualizações. Era por isso que alterar a opção no Gerenciador
      // não tinha nenhum efeito no e-commerce.
      //
      // getPublicApiConfig() já implementa o padrão correto usado pelo
      // restante do e-commerce: em produção busca diretamente (cross-domain,
      // com cache em memória) o config_api.php do Gerenciador, cuja URL é
      // resolvida dinamicamente (ver @/config/gerenciadorConfig.js); em
      // desenvolvimento local usa o proxy same-origin /api/config_api.php.
      getPublicApiConfig()
        .then((config) => {
          console.log("[DEBUG] Configurações públicas do Gerenciador:", config);

          const ocultarPrecoNaoLogado = !!config?.exibicao_precos?.ocultar_preco_nao_logado;

          console.log("[DEBUG] ocultar_preco_nao_logado:", ocultarPrecoNaoLogado);

          this.$store.state.configuracoesSite = {
            ...this.$store.state.configuracoesSite,
            ocultar_preco_nao_logado: ocultarPrecoNaoLogado,
          };

          // Salva no localStorage para persistência
          localStorage.setItem("configuracoesSite", JSON.stringify(this.$store.state.configuracoesSite));

          console.log("[DEBUG] Configurações salvas no store:", this.$store.state.configuracoesSite);
        })
        .catch((error) => {
          console.error("[DEBUG] Erro ao carregar configurações do site:", error);
        });
    }
  },
};
</script>

<style lang="scss">
#bg-video {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -100;
  background-size: cover;
  object-fit: cover;
}

#app {
  font-family: "Roboto", "Montserrat", "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

main {
  min-height: calc(100vh - 200px);
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
  overflow-x: hidden !important;
}

main > .col {
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
}
.admin-section {
  background-color: transparent !important;
  margin-top: 5px !important;
  padding: 5px !important;

  color: black !important;

  * {
    color: black !important;
  }

  .text-small {
    font-size: 15px;
    color: #7c7c7c !important;
  }

  .text-white {
    color: white !important;

    path {
      fill: white !important;
    }
  }

  /* ---primary */
  .bg-primary {
    background-color: var(--primary) !important;
  }
  .bg-primary:focus {
    background-color: var(--primary) !important;
  }
  .bg-primary:hover {
    background-color: var(--primary) !important;
  }

  .btn-primary {
    background-color: var(--primary) !important;
    border: solid 0.1px #afafaf20 !important;
  }
  .btn-primary:focus {
    background-color: var(--primary) !important;
  }
  .btn-primary:hover {
    background-color: var(--primary) !important;
  }

  .btn-outline-primary {
    border-color: var(--primary) !important;
  }

  .btn-outline-primary:hover {
    background-color: var(--primary) !important;
  }

  .text-primary {
    color: var(--primary) !important;
  }
}
.pagination-- {
  .page-item {
    button {
      color: #afafaf !important;
    }
  }
}

.modal-content {
  background: var(--mx3-style-bg-card, #161b26) !important;
  background-color: var(--mx3-style-bg-card, #161b26) !important;
}

/* Alvos: Tablets, iPads e Smartphones deitados */
/* Exclui: Smartphones em pé (<481px) e Desktops/Laptops (>=1280px) */

@media only screen and (min-width: 481px) and (max-width: 1279px) {
  // @media only screen and (min-width: 481px) and (max-width: 1279px) {
  #header-main-
    > div
    > div
    > a.logo.d-flex.align-items-center
    > h1
    > div
    > img {
    width: 100px !important;
    margin-left: 25% !important;
  }
  header > .main-header {
    height: 60px !important;
  }

  .header-actions {
    scale: 1 !important;
    margin-right: unset !important;
  }
  #app
    > main
    > div
    > div
    > div
    > div:nth-child(1)
    > div.show-on-mobile.col
    > div
    > div
    > div.carousel-main-content {
    * {
      font-size: 1.2vh !important;
    }
    .product-badge {
      padding-top: 1px !important;
    }
  }

  #products-container-custom {
    max-width: 100% !important;
  }
  #produto-item- {
    min-width: 205px !important;
    .product-details{
      *{
        font-size:10px !important
      }
    }
  }
  #app
    > main
    > div
    > div
    > div
    > div:nth-child(2)
    > div.show-on-mobile.col
    > div {
    padding-right: 25px !important;
  }
}
/* Ajuste exclusivo para Smartphones Deitados (ex: iPhone 14 Pro Max) */
@media only screen and (min-width: 481px) and (max-width: 932px) and (max-height: 500px) {

  /* Seletor ultra específico baseado no seu XPath para forçar o badge */
  #app > main > div > div > div > div:nth-child(1) > div:nth-child(2) > div > div > div:nth-child(1) > div:nth-child(2) > div > span.product-badge,
  #app > main > div > div > div > div:nth-child(1) > div:nth-child(2) > div > div > div:nth-child(1) > div:nth-child(2) > div > span {
      padding-top: 5px !important;
  }

  /* Ajuste de fonte para o conteúdo */
  #app > main > div > div > div > div:nth-child(1) > div.show-on-mobile.col > div > div > div.carousel-main-content * {
      font-size: 2vh !important;
  }
}
</style>
